<!-- eslint-disable -->
<template lang="pug">
    label.cs-checkbox(
        :class=`{
            'cs-checkbox--disabled': disabled,
            'cs-checkbox--unchecked': !checked,
            'cs-checkbox--small': small
        }`
    )
        input.cs-checkbox__input(type="checkbox", @change="input", :checked="checked")
        div.cs-checkbox__box
            svg-icon.cs-checkbox__icon(name="check", width="16px", height="12px", middle)
        div.cs-checkbox__text
            slot
</template>

<script>
    /*eslint-disable*/
    /**
     * Checkboxes are used for selecting single values like yes or not.
     */
    export default {
        name: 'CsCheckbox',
        status: 'ready',
        release: '1.0.0',
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            /**
             * Boolean value of the checkbox.
             */
            checked: {
                type: Boolean,
                default: false
            },
            /**
             * Property to control disabling of checkbox.
             */
            disabled: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            input (event) {
                this.$emit('change', event.target.checked)
            }
        }
    }
</script>

<style lang="scss" scoped>
    $border-size: 1px;
    .cs-checkbox {
        color: $x-color-black;
        display: flex;
        cursor: pointer;

        margin-bottom: $space-x-small;

        &:hover {
            .cs-checkbox__box {
                border: $border-size solid $hsl-color-blue-56;
            }
        }
    }

    .cs-checkbox__input {
        display: none;
    }

    .cs-checkbox__text {
        display: flex;
        align-items: center;
        padding-left: 10px;
        flex: 1 1 auto;
    }

    .cs-checkbox__box {
        display: block;
        background-color: $x-color-white;
        text-align: center;
        vertical-align: middle;

        border-radius: $border-radius-5;
        border: $border-size solid $hsl-color-gray-74;
        color: $hsl-color-blue-56;

        height: 29px;
        width: 29px;
        min-width: 29px;
        line-height: 29px;
        .cs-checkbox__icon {
            vertical-align: baseline;
        }
    }

    .cs-checkbox--disabled {
        pointer-events: none;

        .cs-checkbox__box {
            color: $hsl-color-gray-74;
            border-color: $hsl-color-gray-82;
            background: #f5f5f5;
            .cs-checkbox__icon {
                vertical-align: baseline;
                opacity: $opacity-disabled;
            }
        }

        .cs-checkbox__text {
            color: #888888;
        }
    }

    .cs-checkbox--unchecked {
        .cs-checkbox__box {
            .cs-checkbox__icon {
                display: none;
            }
        }
    }
</style>
